module.exports = __webpack_public_path__ + "static/media/medicine-ball-throw.46f80104.jpg";